import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ p: 5, position: "relative", display: "inline-flex" }}>
      <CircularProgress
        className="circularprogressbardivided"
        size="10rem"
        thickness={4.4}
        style={{
          zIndex: "9",
          color:
            props.value >= 0 && props.value < 33
              ? "#FF0000"
              : props.value >= 33 && props.value < 66
              ? "#FFA500"
              : props.value >= 66 && props.value < 101
              ? "#008000"
              : "white",
        }}
        variant="determinate"
        {...props}
      />
      <CircularProgress
        className="second-circular-barchart"
        size="9rem"
        variant="determinate"
        value={100}
        thickness={4.4}
        style={{ color: "#2c2556" }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          className="circularsecurity-text"
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default function CircularProgressBarDividedIcon({ percent }) {
  const progress = percent;

  // React.useEffect(() => {
  //   const timer = setInterval(() => {
  //     setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
  //   }, 800);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  return <CircularProgressWithLabel value={progress} />;
}
